import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteBatchApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteBatch = createAsyncThunk('deleteBatch', async (payload) => {
  return await deleteBatchApi(payload);
});

const deleteBatchSlice = createSlice({
  name: 'deleteBatch', // Unique Name
  initialState,
  reducers: {
    deleteBatchReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteBatch.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteBatch.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteBatch.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteBatchReset } = deleteBatchSlice.actions;

export default deleteBatchSlice.reducer;
